module.exports = __webpack_public_path__ + "img/intention.69941274.svg";